import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.to-string.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "poster-share-box"
};
var _hoisted_2 = {
  class: "poster-share",
  id: "poster-share"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "poster-share-title"
};
var _hoisted_5 = {
  class: "share-asin-box"
};
var _hoisted_6 = {
  class: "share-asin-title"
};
var _hoisted_7 = {
  class: "share-asin-info"
};
var _hoisted_8 = {
  class: "share-asin-price"
};
var _hoisted_9 = {
  class: "share-asin-price-unit"
};
var _hoisted_10 = {
  class: "share-asin-price-integer"
};
var _hoisted_11 = {
  class: "share-asin-price-decimal"
};
var _hoisted_12 = {
  class: "share-asin-info-country"
};
import { ref, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import ShareAsinImg1 from '@/components/shareApp/components/shareAsin/ShareAsinImg1.vue';
import ShareAsinImg2 from '@/components/shareApp/components/shareAsin/ShareAsinImg2.vue';
import ShareAsinImg3 from '@/components/shareApp/components/shareAsin/ShareAsinImg3.vue';
import ShareAsinImg4 from '@/components/shareApp/components/shareAsin/ShareAsinImg4.vue';
import ShareAsinImg5 from '@/components/shareApp/components/shareAsin/ShareAsinImg5.vue';
import ShareAsinImg6 from '@/components/shareApp/components/shareAsin/ShareAsinImg6.vue';
import { Bridge } from '@/utils/bridge';
import constants from '@/constants';
import { getAppConfig } from '@/utils/common';
export default {
  __name: 'SharePoster',
  props: ['shareConfiguration'],
  setup(__props) {
    var props = __props;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var IMAGE_URL = constants.IMAGE_URL,
      APP_PAGE_CONFIG_PAGES_ENUM = constants.APP_PAGE_CONFIG_PAGES_ENUM;
    var canvasRef = ref(null);
    var store = useStore();
    var posterBottomImgUrl = ref('');
    var posterContent = ref('');
    // There are six different display forms for shared posters
    var componentAsin = [ShareAsinImg1, ShareAsinImg2, ShareAsinImg3, ShareAsinImg4, ShareAsinImg5, ShareAsinImg6];
    var qrCode = ref('');
    var userName = ref('');
    var getUserInfo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              Bridge.callFn('getCurrentUserInfo', null, infor => {
                var name = infor.name;
                userName.value = name || '';
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getUserInfo() {
        return _ref.apply(this, arguments);
      };
    }();
    var HLOGO_IMAGE_LINK = ref(`${IMAGE_URL}assets/image/hLogo.png`);
    // todo This needs to be provided by the API.
    var priceData = reactive({
      integer: 0,
      decimal: 0
    });
    var getSettingPageConfig = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return getAppConfig(APP_PAGE_CONFIG_PAGES_ENUM.SETTING_PAGE);
            case 3:
              res = _context2.sent;
              posterBottomImgUrl.value = res.posterUnderlay.imgUrls[0];
              posterContent.value = res.posterUnderlay.content.q || t('modules.share.RECOMMEND_EXCELLENT_PRODUCTS_TO_YOU');
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.error('func getSettingPageConfig catch error', _context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 8]]);
      }));
      return function getSettingPageConfig() {
        return _ref2.apply(this, arguments);
      };
    }();
    var convertImgUrlToBase64Format = (el, url, outputFormat = '') => {
      return new Promise(resolve => {
        var canvas = el;
        setTimeout(() => {
          var ctx = canvas.getContext('2d');
          var img = new Image();
          img.crossOrigin = 'Anonymous';
          img.src = url;
          img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            var dataURL = canvas.toDataURL(outputFormat || 'image/jpg');
            resolve(dataURL);
          };
        }, 300);
      });
    };
    var getQRCode = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _props$shareConfigura;
        var centerImageBase64, _yield$Bridge$callFnV, imageBase64;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return convertImgUrlToBase64Format(canvasRef.value, `${IMAGE_URL}assets/image/icon-app-logo.png`, 'image/png');
            case 2:
              centerImageBase64 = _context3.sent;
              _context3.next = 5;
              return Bridge.callFnVal('generateQRCodeImage', {
                content: (_props$shareConfigura = props.shareConfiguration) === null || _props$shareConfigura === void 0 ? void 0 : _props$shareConfigura.shareUrl,
                centerImageBase64
              });
            case 5:
              _yield$Bridge$callFnV = _context3.sent;
              imageBase64 = _yield$Bridge$callFnV.imageBase64;
              qrCode.value = imageBase64;
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function getQRCode() {
        return _ref3.apply(this, arguments);
      };
    }();
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _props$shareConfigura2, _props$shareConfigura3, _props$shareConfigura4, _priceAmount$split$, _priceAmount$split$2;
      var priceAmount;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            priceAmount = (_props$shareConfigura2 = props.shareConfiguration) === null || _props$shareConfigura2 === void 0 ? void 0 : (_props$shareConfigura3 = _props$shareConfigura2.asinInfo) === null || _props$shareConfigura3 === void 0 ? void 0 : (_props$shareConfigura4 = _props$shareConfigura3.ourPrice) === null || _props$shareConfigura4 === void 0 ? void 0 : _props$shareConfigura4.amount.toString();
            priceData.integer = (_priceAmount$split$ = priceAmount === null || priceAmount === void 0 ? void 0 : priceAmount.split('.')[0]) !== null && _priceAmount$split$ !== void 0 ? _priceAmount$split$ : 0;
            priceData.decimal = (_priceAmount$split$2 = priceAmount === null || priceAmount === void 0 ? void 0 : priceAmount.split('.')[1]) !== null && _priceAmount$split$2 !== void 0 ? _priceAmount$split$2 : 0;
            _context4.next = 5;
            return getSettingPageConfig();
          case 5:
            _context4.next = 7;
            return getQRCode();
          case 7:
            _context4.next = 9;
            return getUserInfo();
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    return (_ctx, _cache) => {
      var _component_van_divider = _resolveComponent("van-divider");
      var _component_asin_tag = _resolveComponent("asin-tag");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        style: {
          "display": "none"
        }
      }, null, 512), _createElementVNode("img", {
        class: "icon-app",
        src: HLOGO_IMAGE_LINK.value,
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('modules.share.AMAZON_OVERSEAS_PURCHASING_USERS') + userName.value), 1), _createVNode(_component_van_divider, {
        class: "recommend-title-box"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(posterContent.value), 1)]),
        _: 1
      }), (_openBlock(), _createBlock(_resolveDynamicComponent(componentAsin[_unref(store).getters['share/picNumSeclected']]))), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(__props.shareConfiguration.asinInfo.title), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('common.currencyUnit')), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(priceData.integer), 1), _createElementVNode("span", _hoisted_11, "." + _toDisplayString(priceData.decimal), 1)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_asin_tag, {
        type: __props.shareConfiguration.asinInfo.merchant_badge
      }, null, 8, ["type"])])])]), _createElementVNode("div", {
        class: "poster-bottom",
        style: _normalizeStyle({
          background: `url(${posterBottomImgUrl.value})`,
          backgroundSize: '100% 100%'
        })
      }, [_createElementVNode("div", {
        class: "card-box",
        style: _normalizeStyle({
          backgroundImage: `url(${qrCode.value})`,
          backgroundSize: '100% 100%'
        })
      }, null, 4)], 4)])]);
    };
  }
};